import styled from '@emotion/styled';

export default styled('div')`
  margin: -4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  > * {
    margin: 4px;
  }
`;
